<template>
  <el-dialog
    :close-on-click-modal="false"
    append-to-body
    v-model="visible"
    modal-class="is--form"
    :title="$t(`registration.payment.pay`)"
    width="550px"
    align-center
    @close="handleClose"
  >
    <el-form ref="formRefs" :model="form" label-position="top">
      <div class="preorder">
        <p v-if="$event.Config.Discount">
          <span class="label">{{ $t(`registration.payment.pay-total`) }}</span>
          <span class="text">
            <em class="animate__animated animate__fadeIn">
              {{ Number(preOrder.PaymentTotalFee).toFixed(2) }}
            </em>
          </span>
        </p>
        <p v-if="$event.Config.Discount">
          <span class="label">{{ $t(`registration.payment.pay-discount`) }}</span>
          <span class="text">
            <em class="animate__animated animate__fadeIn">
              {{ Number(preOrder.PaymentDiscountTotalFee).toFixed(2) }}
            </em>
          </span>
        </p>
        <p>
          <span class="label">{{ $t(`registration.payment.pay-tbp`) }}</span>
          <span class="text tp">
            <em class="animate__animated animate__fadeIn">
              {{ Number(preOrder.PaymentTotalFee).toFixed(2) }}
            </em>
          </span>
        </p>
      </div>

      <el-form-item>
        <div class="pay-header">{{ $t(`registration.payment.pay-tips`) }}</div>
        <el-radio-group v-model="form.payway" @change="() => handlePayway()">
          <el-radio v-if="payment.wx" class="wx" label="wx_EventMaster" border>{{
            $t(`registration.payment.pay-wx`)
          }}</el-radio>
          <el-radio v-if="payment.ali" class="ali" label="ali_EventMaster" border>{{
            $t(`registration.payment.pay-ali`)
          }}</el-radio>
          <el-radio
            v-if="payment.paypal"
            class="paypal"
            label="papal_EventMaster"
            border
            >{{ $t(`registration.payment.pay-papal`) }}</el-radio
          >
          <el-radio
            v-if="payment.transfer"
            class="transfer"
            label="Transfer_EventMaster"
            border
            >{{ $t(`registration.payment.pay-transfer`) }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item style="margin-bottom: 0">
        <template v-if="form.payway === 'wx_EventMaster' && payURL">
          <div class="qr">
            <img
              :src="`http://www.dataleading.cn/barcode/img.ashx?type=2d&text=${payURL}`"
            />
          </div>
          <div class="tips">{{ $t(`registration.payment.pay-wx-tips`) }}</div>
        </template>
        <template v-else-if="form.payway === 'Transfer_EventMaster'">
          <template
            v-for="g in $config.payment.filter((x) => x.type === 'Transfer_EventMaster')"
          >
            <div class="transfer-wrapper">
              <div class="items">
                <span>{{ ["银行账号：", "Bank account number:"][$language] }}</span>
                <strong>{{ g.Partner }}</strong>
              </div>
              <div class="items">
                <span>{{ ["开户行名称：", "Bank name:"][$language] }}</span>
                <strong>{{ g.Username }}</strong>
              </div>
              <div class="items">
                <span>{{ ["帐户名：", "Account name:"][$language] }}</span>
                <strong>{{ g.Password }}</strong>
              </div>
              <div class="items">
                <span>{{ ["备注：", "Remark:"][$language] }}</span>
                <strong>{{ g.NRemark }}</strong>
              </div>
              <div class="btns">
                <el-button type="primary" @click="handlePayway('Transfer_EventMaster')">{{
                  ["已转帐", "Transfered"][$language]
                }}</el-button>
              </div>
            </div>
          </template>
        </template>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { handleError, onMounted, ref, defineExpose, inject, computed } from "vue";

import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { isWeixin } from "@/utils";
import { createOrder } from "@/api/registration";
import { createPayment, checkPaymentStatus } from "@/api/payment";
import { useAppStore } from "@/store/modules/app";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const { t, te } = useI18n();
const $language = inject("$language");
const visible = ref(false);
const emit = defineEmits(["close", "paid"]);
const formRefs = ref(null);

//
const form = ref({ payway: "" });
const order = ref("");
const payURL = ref({});
const preOrder = ref({});

const { config, event } = storeToRefs(useAppStore());
const $config = inject("$config");
const $event = inject("$event");
const payment = computed(() => {
  let obj = { wx: false, ali: false, paypal: false, transfer: false };
  //
  for (var g of $config.value.payment) {
    if (g.type.toLocaleLowerCase().indexOf("wx_") >= 0) {
      obj.wx = true;
    }
    if (g.type.toLocaleLowerCase().indexOf("ali_") >= 0) {
      obj.ali = true;
    }
    if (g.type.toLocaleLowerCase().indexOf("papal_") >= 0) {
      obj.paypal = true;
    }
    if (g.type.toLocaleLowerCase().indexOf("transfer_") >= 0) {
      obj.transfer = true;
    }
  }
  return obj;
});

const interval = ref(null);
//
const handlePayway = async (val) => {
  if (val !== "Transfer_EventMaster") {
    if (form.value.payway === "Transfer_EventMaster") {
      return;
    }
  }
  const loading = ElLoading.service({ fullscreen: true });
  interval.value && clearInterval(interval.value);
  payURL.value = "";
  const { data: order } = await createOrder(form.value.rows, {
    payway: form.value.payway,
    url: window.location.href,
  });
  console.log(order);
  if (order.payway && order.payway === "FREE") {
    loading.close();
    emit("paid");
    return;
  }
  if (form.value.payway === "Transfer_EventMaster") {
    loading.close();
    router.push({ name: "confirmation" });
    return;
  }
  try {
    const { data } = await createPayment({ out_trade_no: order.OutTradeNo });
    loading.close();
    if (data.type === "qr") {
      payURL.value = encodeURIComponent(data.data.url);
    } else if (data.type == "link" || data.type === "redirect") {
      window.location.href = data.data.url;
    } else if (data.type === "jsapi") {
      console.log(data);
    }
    interval.value = setInterval(async () => {
      const { data: s } = await checkPaymentStatus({ out_trade_no: order.OutTradeNo });
      console.log(interval.value);
      if (s.status === 1) {
        interval.value && clearInterval(interval.value);
        visible.value = false;
        ElMessage({ message: t(`registration.payment.pay-ok`), type: "success" });
        emit("paid");
      }
    }, 3000);
  } catch (e) {}
  //  payURL.value[val] = encodeURIComponent(`${config.value.app.host}/Payment?v=${event.value.ID}&out_trade_no=${data.id}`)
};

const handleClose = () => {
  interval.value && clearInterval(interval.value);
};

defineExpose({
  show: async (rows) => {
    const loading = ElLoading.service({ fullscreen: true });
    //const { data } = await createOrder(rows)
    form.value = {
      rows: rows,
      payway: "",
    };
    try {
      const { ret, data } = await createOrder(form.value.rows, { payway: "" });
      console.log(data);
      if (data.payway && data.payway === "FREE") {
        emit("paid");
        return;
      }
      preOrder.value = data;
      visible.value = true;
    } catch (e) {
      console.log(e);
      if (e.ret === 510699) {
        emit("paid");
      }
    } finally {
      loading.close();
    }
  },
});
</script>

<style lang="scss" scoped>
.share {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9000;
  background-color: #fff;
  background-image: url(~@/assets/img/pay-share.jpg);
  background-repeat: no-repeat;
  background-size: contain;
}
.el-radio-group {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  :deep() {
    .el-radio__input {
      display: none;
    }
    .el-radio {
      margin-right: 18px;
      background: #f8f9fa;
      border: 1px solid #dadfe3;
      border-radius: 4px;
      color: #363f5e;
      height: 32px;
      padding-left: 32px;
      padding-right: 9px;

      background-position: 6px center;
      background-repeat: no-repeat;
      background-size: 24px 24px;
      &:last-child {
        margin-right: 0;
      }
      .el-radio__label {
        margin-left: 0;
        padding-left: 0;
      }
      &.wx {
        background-image: url(~@/assets/img/pay-wx-1.png);
      }
      &.ali {
        background-image: url(~@/assets/img/pay-ali-1.png);
      }
      &.paypal {
        background-image: url(~@/assets/img/pay-paypal-1.png);
      }
      &.transfer {
        background-image: url(~@/assets/img/pay-transfer-1.png);
      }
      &.is-checked {
        border-color: var(--el-color-primary);
        color: var(--el-color-primary);
        background-color: var(--el-color-primary-light-9);

        &.wx {
          background-image: url(~@/assets/img/pay-wx-1.png);
        }
        &.ali {
          background-image: url(~@/assets/img/pay-ali-1.png);
        }
        &.paypal {
          background-image: url(~@/assets/img/pay-paypal-1.png);
        }
        &.transfer {
          background-image: url(~@/assets/img/pay-transfer-1.png);
        }
      }
    }
  }
}

.qr {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  background: #f1f4f9;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 7px;
  margin-bottom: 8px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
  }
}
.tips {
  line-height: 20px;
  color: #353b55;
  width: 100%;
  text-align: center;
}

.preorder {
  margin-bottom: 20px;
  border-bottom: solid 1px #f0f0f0;
  padding-bottom: 20px;
  p {
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    span {
      &.text {
        font-weight: normal;
        color: #666;
        em {
          text-decoration: none;
          font-style: normal;
        }
      }
      &.tp {
        color: var(--el-color-primary);
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
.pay-header {
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 760px) {
  .el-radio-group {
    flex-wrap: nowrap;
    :deep() {
      .el-radio {
        margin-right: 6px;
        padding-left: 30px;
        padding-right: 6px;
      }
    }
  }
}

.transfer-wrapper {
  background-color: #f0f0f0;
  width: 100%;
  border-radius: 3px;
  padding: 12px;
  > div {
    width: 100%;
    text-align: center;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 6px;
  }
  .btns {
    display: flex;
    justify-content: center;
  }
}
</style>
